(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("dotenv"));
	else if(typeof define === 'function' && define.amd)
		define(["dotenv"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("dotenv")) : factory(root["dotenv"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(global, (__WEBPACK_EXTERNAL_MODULE__254__) => {
return 